import checklistIcon from '@assets/icons/ChecklistIconWithoutShadow.svg';
import clockIcon from '@assets/icons/ClockIconWithoutShadow.svg';

const BigStatusIcon = ({
    status,
    styles
}: {
    status: 'COMPLETED' | string
    styles?: React.CSSProperties
}) => {
    switch (status) {
        case "COMPLETED":
            return <img src={checklistIcon} alt="Checklist icon" style={styles} />
        default:
            return <img src={clockIcon} alt="Clock icon" style={styles} />
    }
}

export default BigStatusIcon;
